<template>
  <tr>
    <td v-text="limit.name" />
    <td v-text="limit.payout_limits.daily_limit" />
    <td v-text="limit.payout_limits.weekly_limit" />
    <td v-text="limit.payout_limits.monthly_limit" />
    <td align="end">
      <v-btn
        icon
        @click="$emit('edit', limit.entity_id)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        icon
        color="error"
        @click="$emit('delete', { ...limit, payout_limits: {} })"
      >
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    limit: Object,
    required: true,
  }
}
</script>
